import React from "react";
import "./services.css";
import Carousel from "../../components/carousel/Carousel";

const Services = () => {
  return (
    <section id="services">
      <h2>Compétences</h2>
      <p>
        L'écosystème technologique que je maîtrise et exploite au quotidien pour construire, sécuriser et superviser des environnements de production.
      </p>
      <div className="container services__container" data-aos="fade-up">
        <Carousel />
      </div>
    </section>
  );
};

export default Services;
